import React, { useEffect, useState } from 'react';
import {
    Table,
    TableBody,
    TableCell,
    TableContainer,
    TableHead,
    TableRow,
    Paper,
    Typography,
    Box,
    Button,
    Divider,
    Container
} from '@mui/material';
import { useNavigate, useParams } from 'react-router-dom';
import { useOrderStore } from '../store/useOrderStore';
import Loader from './Loader/Loader';

export default function OrderDetails() {
    const { id } = useParams();
    const { getOrderById, loading } = useOrderStore();
    const [product, setProduct] = useState([]);
    const [order, setOrderDetails] = useState();
    const navigate = useNavigate();

    useEffect(() => {
        const fetchOrder = async () => {
            try {
                const data = await getOrderById(id);
                if (data) {
                    const { ref, productDetails } = data;
                    if (ref) setOrderDetails(ref);
                    if (productDetails) setProduct(productDetails);
                }
            } catch (error) {
                console.error("Order fetch error:", error);
            }
        };

        fetchOrder();
    }, [id]);

    return (
        <>
            <div className="bg-grey" style={{marginBottom: "70px", backgroundColor: '#f7f5f5', borderRadius: "4px", padding: '20px 20px 50px' }} >
                <Container sx={{
                    marginBottom: "60px",
                    marginTop: '60px',
                }}>
                    <Box>
                        <Loader loading={loading} />
                        <Typography sx={{
                            fontSize: '24px',
                            lineHeight: '28.8px',
                            fontWeight: '700',
                            fontFamily: `"Quicksand", sans-serif`,
                            color: '#253D4E',
                            paddingBottom: '16px',
                            borderBottom: '1px solid #00000024',
                            marginBottom: '15px',
                            position: 'relative',
                            '&::before': {
                                content: `""`,
                                width: '80px',
                                height: '2px',
                                background: '#008BFF',
                                position: 'absolute',
                                left: '0',
                                bottom: '0',
                            },
                        }}>Order Details</Typography>
                        {/* Product Table */}
                        <TableContainer sx={{ mb: 4, backgroundColor: '#fff', border: '1px solid #ccc', borderRadius: "4px" }}>
                            <Table>
                                <TableHead>
                                    <TableRow>
                                        <TableCell><strong>Image</strong></TableCell>
                                        <TableCell><strong>Product</strong></TableCell>
                                        <TableCell><strong>Brand</strong></TableCell>
                                        <TableCell><strong>Color</strong></TableCell>
                                        <TableCell><strong>Price</strong></TableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {(product || []).map((ele, i) => (
                                        <TableRow key={i}>
                                            <TableCell>
                                                <img
                                                    src={ele?.images?.[0] || "/fallback.jpg"}
                                                    alt={ele?.name || "Product"}
                                                    style={{ width: '60px', height: '60px', objectFit: 'contain', borderRadius: '4px', border: "1px solid #2D3C67", }}
                                                />
                                            </TableCell>
                                            <TableCell>{ele?.name}</TableCell>
                                            <TableCell>{ele?.brand}</TableCell>
                                            <TableCell>{ele?.color}</TableCell>
                                            <TableCell>${ele?.total}</TableCell>
                                        </TableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>

                        {/* Status and Address Section */}
                        <Box sx={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: '20px',
                            backgroundColor: '#fff',
                            padding: '20px',
                            borderRadius: '4px',
                            border: '1px solid #ccc',
                            mb: 4,
                        }}>
                            <Typography variant="h6" gutterBottom sx={{ marginBottom: '0' }}>Status :</Typography>
                            <Typography variant="body1" color="white" sx={{ background: 'green', padding: '5px 10px', borderRadius: '50px', marginLeft: '10px', }}>
                                {order?.orderStatus}
                            </Typography>
                        </Box>
                        <Box sx={{
                            display: 'flex',
                            flexWrap: 'wrap',
                            gap: '20px',
                            backgroundColor: '#fff',
                            padding: '20px',
                            borderRadius: '4px',
                            border: '1px solid #ccc',
                            mb: 4,
                        }}>
                            <Box sx={{
                                width: '100%'
                            }}>
                                <Typography sx={{
                                    fontSize: '24px',
                                    lineHeight: '28.8px',
                                    fontWeight: '700',
                                    fontFamily: `"Quicksand", sans-serif`,
                                    color: '#253D4E',
                                    paddingBottom: '10px',
                                    borderBottom: '1px solid #00000024',
                                    margin: "15px 0 20px",
                                    position: 'relative',
                                    '&::before': {
                                        content: `""`,
                                        width: '80px',
                                        height: '2px',
                                        background: '#008BFF',
                                        position: 'absolute',
                                        left: '0',
                                        bottom: '0',
                                    },
                                }}>  Delivery Address</Typography>
                                <Typography variant="body2" sx={{ mb: 1 }}><strong>Name:</strong> {order?.shippingAddress?.fullName}</Typography>
                                <Typography variant="body2" sx={{ mb: 1 }}><strong>Phone:</strong> {order?.shippingAddress?.phone}</Typography>
                                <Typography variant="body2" sx={{ whiteSpace: 'pre-line', mb: 1 }}>
                                    <strong>Address:</strong> <br />
                                    {order?.shippingAddress?.apartment}, {order?.shippingAddress?.streetAddress} <br />
                                    {order?.shippingAddress?.city}, {order?.shippingAddress?.state} - {order?.shippingAddress?.zipCode}
                                </Typography>

                                <Divider sx={{ my: 2 }} />
                                <Typography sx={{
                                    fontSize: '24px',
                                    lineHeight: '28.8px',
                                    fontWeight: '700',
                                    fontFamily: `"Quicksand", sans-serif`,
                                    color: '#253D4E',
                                    paddingBottom: '10px',
                                    borderBottom: '1px solid #00000024',
                                    margin: "15px 0 20px",
                                    position: 'relative',
                                    '&::before': {
                                        content: `""`,
                                        width: '80px',
                                        height: '2px',
                                        background: '#008BFF',
                                        position: 'absolute',
                                        left: '0',
                                        bottom: '0',
                                    },
                                }}>  Price Details</Typography>
                                <Typography variant="body2">Item Price: ${order?.totalAmountBeforeCoupon}</Typography>
                                <Typography variant="body2">Delivery: $0</Typography>
                                <Typography variant="subtitle1" sx={{ fontWeight: 'bold', mt: 1 }}>
                                    Total: ${order?.totalAmountAfterCoupon}
                                </Typography>
                            </Box>
                        </Box>

                        {/* Action Button */}
                        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
                            <Button
                                variant="contained"
                                onClick={() => navigate("/orders")}
                                sx={{
                                    width: "300px",
                                    height: "46px",
                                    borderRadius: "6px",
                                    backgroundColor: "#008BFF",
                                    color: "#fff",
                                    fontSize: "16px",
                                    fontWeight: "500",
                                    fontFamily: `"Quicksand", sans-serif`,
                                    textTransform: "capitalize",
                                    "&:hover": {
                                        backgroundColor: "#0070cc"
                                    }
                                }}
                            >
                                Back To Orders
                            </Button>
                        </Box>
                    </Box>
                </Container>
            </div>
        </>

    );
}
